import { createFileRoute, redirect } from '@tanstack/react-router';

import { resolveLocale } from '../lib/i18n';

/**
 * `/` has no locale, and every real screen does (spec 4.2). Resolution order is stored
 * preference → browser languages → English; see lib/i18n.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/$lang', params: { lang: resolveLocale() }, replace: true });
  },
});
